<template>
    <v-card>
        <v-tabs>
            <v-tab>
                Probes
            </v-tab>
            <v-tab-item>
                <data-analytics-filter-card/>
                <probe-data-list-table/>
            </v-tab-item>
            <v-tab>
                Recommendations
            </v-tab>
            <v-tab-item>
                <v-card>
                    <data-analytics-recommendation-generate-card/>
                    <data-analytics-recommendation-list-card/>
                </v-card>
            </v-tab-item>
            <v-tab>
                AF0
            </v-tab>
            <v-tab-item>
                <v-card>
                    <data-analytics-af0-generate-card/>
                    <data-analytics-af0-list-card/>
                </v-card>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { PermissionsConstants } from '@/permissions';
import { mapActions, mapState } from 'vuex';
import ProbeDataListTable from '@/components/data-analytics/DataAnalyticsListTable';
import DataAnalyticsFilterCard from '@/components/data-analytics/DataAnalyticsFilterCard';
import DataAnalyticsRecommendationListCard
    from '@/components/data-analytics/DataAnalyticsRecommendationListCard.vue';
import DataAnalyticsRecommendationGenerateCard
    from '@/components/data-analytics/DataAnalyticsRecommendationGenerateCard.vue';
import DataAnalyticsAf0GenerateCard
    from '@/components/data-analytics/DataAnalyticsAf0GenerateCard.vue';
import DataAnalyticsAf0ListCard
    from '@/components/data-analytics/DataAnalyticsAf0ListCard.vue';

export default {
    name: 'DataAnalytics',
    components: {
        'probe-data-list-table': ProbeDataListTable,
        'data-analytics-filter-card': DataAnalyticsFilterCard,
        'data-analytics-recommendation-list-card': DataAnalyticsRecommendationListCard,
        'data-analytics-recommendation-generate-card': DataAnalyticsRecommendationGenerateCard,
        'data-analytics-af0-generate-card': DataAnalyticsAf0GenerateCard,
        'data-analytics-af0-list-card': DataAnalyticsAf0ListCard,
    },
    computed: {
        ...mapState('auth', ['user']),
    },
    methods: {
        ...mapActions('auth', ['logOut']),
        ...mapActions('analytics', ['fetchDataAnalyticsFilterObjects']),
    },
    mounted() {
        if (this.loggedIn && (this.user?.user_permissions?.analytics?.length === 0 || !this.user?.user_permissions?.analytics?.includes(PermissionsConstants.VIEW))) {
            this.logOut();
        }
    },
    async created() {
        await this.fetchDataAnalyticsFilterObjects();
    },
};
</script>

<style scoped>

</style>